import { LoopingCarousel } from '@cinch-nx/shared-ui'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { SbBlokData } from '@storyblok/react'
import MarketingCard from './marketing-card/marketing-card'
import styles from './marketing-carousel.module.css'

interface MarketingCarouselProps {
  slides: SbBlokData[]
  slideSpeedInSeconds?: number
  shouldLoop?: boolean
}

const marketingCarouselStoryblokComponents = {
  MarketingCard,
}

export default function MarketingCarousel({
  slides = [],
  slideSpeedInSeconds = 2,
  shouldLoop = true,
}: MarketingCarouselProps) {
  if (slides.length === 0) {
    return null
  }

  return (
    <LoopingCarousel
      slideSpeedInSeconds={slideSpeedInSeconds}
      shouldLoop={shouldLoop}
      swiperSettings={{
        slidesPerView: 1.1,
        spaceBetween: 12,
        pagination: { dynamicBullets: false },
        breakpoints: {
          425: { slidesPerView: 1.2 },
          514: { slidesPerView: 1.5 },
          576: { slidesPerView: 1.7 },
          722: { slidesPerView: 2.2 },
          768: { slidesPerView: 2.3 },
          869: { slidesPerView: 2.9 },
          962: { slidesPerView: 2.7 },
          1024: { slidesPerView: 1 },
        },
      }}
      className={{
        carousel: styles.carousel,
        carouselSlide: styles.carouselSlide,
        controlsWrapper: styles.controlsWrapper,
        customPagination: styles.customPagination,
      }}
    >
      {slides.map((slide, index) => {
        const heading = (slide.heading as string) || `Slide ${index + 1}`
        const ariaLabel = `${heading}, slide ${index + 1} of ${slides.length}`
        return (
          <LoopingCarousel.Slide key={slide._uid} ariaLabel={ariaLabel}>
            <StoryblokRenderer
              block={slide}
              components={marketingCarouselStoryblokComponents}
            />
          </LoopingCarousel.Slide>
        )
      })}
    </LoopingCarousel>
  )
}
